<aur-mat-table
  [tableData]="history()"
  [tableConfig]="tableConfig()"
  [paginatorState]="pagination().paginatorState"
  (pageChange)="pageChange.emit($event)"
  (sort)="sortChange.emit($event)">
  <ng-template ngxAurHeaderCellDef="action" let-column>
    <span class="action-header">{{ column.name }}</span>
  </ng-template>

  <ng-template ngxAurCellDef="action" let-action let-history="rowSrc">
    <span class="driver-link-cell">
      <mat-icon>{{ actionIcon(history) }}</mat-icon>
      <span>{{ action }}</span>
    </span>
  </ng-template>
</aur-mat-table>
